import React, { Component } from 'react'
import { Button, Table, Modal, Spin, message, Upload, Icon, Select,Radio, Input, } from "antd"
import styled from "styled-components"
import UploadAPI from '@/API/upload'
import operatorAPI from '@/API/operator'
import Filter from '@/components/UploadIMEI/Filter'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import dayjs from 'dayjs'

const { Option } = Select;
const Div=styled.div`
  margin-bottom: 10px;
`

const UploadTable=styled(Table)`
  margin:0 20px;
`
const MyUpload=styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

class UploadIMEI extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      filter:{
        type:0
      },
      operatorList:[],
      productList:[],
      operator:"",
      productName:"",
      uploadList:[],
      dialogShow:false,
      fileList:[],
      deleteDialogShow:false,
      deleteFileList:[],
      confirmLoading:false,
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      radioValue: 1,
      singelIMEI:'',
      deleteSingelIMEI:'',
      deleteRadioValue:1
    };
    this.agentColumns=[
      {
        title:this.props.t('Upload Date'),
        dataIndex:'time',
        render:(text)=>(dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title:this.props.t('Total Devices'),
        dataIndex:'totalCount'
      },
      {
        title:this.props.t('Successful'),
        dataIndex:'succeedCount'
      },
      {
        title:this.props.t('Failed'),
        dataIndex:'failedCount'
      },
      {
        title:this.props.t('Uploaded By'),
        dataIndex:'userName'
      },
      {
        title:this.props.t('Carrier Code'),
        dataIndex:'operator'
      },
      {
        title:this.props.t('Model'),
        dataIndex:'productName'
      }
    ]
    this.operatorColumns=[
      {
        title:this.props.t('Upload Date'),
        dataIndex:'time',
        render:(text)=>(dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title:this.props.t('Total Devices'),
        dataIndex:'totalCount'
      },
      {
        title:this.props.t('Successful'),
        dataIndex:'succeedCount'
      },
      {
        title:this.props.t('Failed'),
        dataIndex:'failedCount'
      },
      {
        title:this.props.t('Uploaded By'),
        dataIndex:'userName'
      },
      {
        title:this.props.t('Carrier Code'),
        dataIndex:'operator'
      },
      {
        title:this.props.t('Type'),
        dataIndex:'operateType',
        render:(text)=>(text?this.props.t("Delete"):this.props.t("Upload"))
      }
    ]
  }

  componentDidMount() {
    this.getUploadList()
    this.getOperatorCodeList()
  }
  
  getColumns=()=>{
    const {filter}=this.state
    const {roleId}=this.props
    if(roleId==1||roleId==2){
      return filter.type?this.agentColumns:this.operatorColumns
    } else if(roleId==3){
      return this.operatorColumns;
    }else {
      return this.agentColumns;
    }
  }
  filterChange=(key,value)=>{
    let field={}
      field[key]=value
      this.setState(prevState=>({
        filter:{
          ...prevState.filter,
          ...field
        }
      }))
    this.setState({
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      }
    },()=>{
      this.getUploadList()
    })
  }

  getOperatorCodeList=()=>{
    operatorAPI.getOperatorCodeList().then((res)=>{
      console.log(res)
      this.setState({operatorList:res})
    })
  }
  getUploadList=()=>{
    this.setState({loading:true})
    const {filter,pagination}=this.state
    const {roleId}=this.props
    if(!roleId){
      return setTimeout(()=>{
        this.getUploadList()
      },500)
    }
    if(roleId==1||roleId==2){
      var api = filter.type?"getAgentUploadIMEI":"getLockUploadIMEI"
    } else if(roleId==3||roleId==7){
      var api = "getLockUploadIMEI"
    }else {
      var api = "getAgentUploadIMEI"
    }
    UploadAPI[api]({pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      this.setState((state)=>{
        return {uploadList:res.data,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getUploadList()
    });
  }
  initDialog=()=>{
    this.setState({dialogShow:true,singelIMEI:''})
  }
  initDeleteDialog=()=>{
    this.setState({deleteDialogShow:true})
  }
  uploadInit=()=>{
    this.setState({
      operator:'',
      productName:'',
      productList:[],
      fileList:[],
      singelIMEI:''
    })
  }
  deleteUploadInit=()=>{
    this.setState({
      deleteFileList:[],
      deleteSingelIMEI:''
    })
  }
  handleCancel=()=>{
    this.setState({
      dialogShow:false,
      fileList:[]
    })
  }
  handleDeleteCancel=()=>{
    this.setState({
      deleteDialogShow:false,
      deleteFileList:[]
    })
  }
  handleOk=()=>{    
    var {operator,productName,fileList,radioValue,singelIMEI}=this.state
    var {t,roleId}=this.props
    var formData=new FormData()    
    // 代理商和多选
    if(roleId===5 && radioValue ===0){
      if(!operator){
        return message.warning(t("Select a carrier code."))
      }
      if(!productName){
        return message.warning(t("Select a model."))
      }
      if(!fileList.length){
        return message.warning(t("Upload an IMEI table."))
      }      
      formData.append('operator',operator)
      formData.append('productName',productName)
      formData.append('file',fileList[0])
      UploadAPI.agentUpload(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
    // 代理商和单选
    }else if(roleId===5 && radioValue ===1){
      if(!operator){
        return message.warning(t("Select a carrier code."))
      }
      if(!productName){
        return message.warning(t("Select a model."))
      }
      if(!singelIMEI){
        return message.warning(t("Please enter an IMEI."))
      }      
      formData.append('operator',operator)
      formData.append('productName',productName)
      formData.append('imei',singelIMEI)      
      UploadAPI.agentUploadSingle(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
      //运营商和仓库多选
    }else if((roleId===3||roleId===7) && radioValue ===0){
      if(!fileList.length){
        return message.warning(this.props.t('Import IMEIs first.'))
      }      
      formData.append('file',fileList[0])
      UploadAPI.operatorUpload(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
      //运营商和仓库单个
    }else if((roleId===3||roleId===7) && radioValue ===1){
      if(!singelIMEI){
        return message.warning(this.props.t('Import IMEIs first.'))
      }      
      formData.append('imei',singelIMEI)   
      //debugger     
      UploadAPI.operatorUploadSingel(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
    }
  }
  handleDeleteOk=()=>{
    var {deleteFileList,deleteSingelIMEI,deleteRadioValue}=this.state
    const {t}=this.props
    //debugger
    var formData=new FormData();
    if(deleteRadioValue){
      if(!deleteSingelIMEI){
        return message.warning(this.props.t('Import IMEIs first.'))
      }
      formData.append('imei',deleteSingelIMEI) 
      //debugger     
      UploadAPI.operatorDeleteUploadSingel(formData).then((res)=>{
        if(!res.code){
          message.success(t("Delete successfully."))
          this.deleteUploadInit()
          this.setState({dialogShow:false})
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Delete failed."))
      })
    }else{
      //批量删除
      if(!deleteFileList.length){
        return message.warning(this.props.t('Import IMEIs first.'))
      }     
      formData.append('file',deleteFileList[0])
      UploadAPI.operatorDeleteUpload(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.deleteUploadInit()
          this.setState({deleteDialogShow:false})
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
    }
  }
  handleOperatorChange=(value)=>{
    this.setState({operator:value},()=>{
      this.getProductList()
    })
  }
  handleProductChange=(value)=>{
    this.setState({productName:value})
  }
  getProductList=()=>{
    operatorAPI.getProductList({operator:this.state.operator}).then((res)=>{
      this.setState({productList:res})
    })
  }
  changeRadio = e => {    
    this.setState({radioValue: e.target.value})    
  };
  changeDeleteRadio = e => {    
    this.setState({deleteRadioValue: e.target.value})    
  };
  changeInput = e => {
    this.setState({singelIMEI: e.target.value});    
  }
  changeDeleteInput = e => {
    this.setState({deleteSingelIMEI: e.target.value});    
  }
  
  render() {
    const {uploadList,loading,pagination,dialogShow,fileList,operatorList,productList,deleteDialogShow,deleteFileList,radioValue,singelIMEI,deleteSingelIMEI,    deleteRadioValue} = this.state
    const { t,roleId } = this.props
    const props = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState({fileList:[file]})
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({fileList:[]})
      }
    }
    const deleteProps = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState({deleteFileList:[file]})
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({deleteFileList:[]})
      }
    }
    return (
      <div>
        <Filter filterChange={this.filterChange} initDeleteDialog={this.initDeleteDialog} initDialog={this.initDialog}></Filter>
        <Spin spinning={loading}>
          <UploadTable dataSource={uploadList} columns={this.getColumns()} pagination={pagination} rowKey="id" onChange={this.handleTableChange}></UploadTable>
        </Spin>
        {
          dialogShow&&(
            <Modal title={t('Import IMEI')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} okText={t('OK')}>
              {
                roleId===5 && (
                  <div>
                    <Div>
                      <Select placeholder={t("Select carrier")} style={{ width: 300 }} onChange={this.handleOperatorChange}>
                        {
                          operatorList.map((operator)=>(
                            <Option value={operator} key={operator}>{operator}</Option>
                          ))
                        }
                      </Select>
                    </Div>
                    <Div>
                      <Select placeholder={t("Select model")} style={{ width: 300 }} onChange={this.handleProductChange}>
                        {
                          productList.map((product)=>(
                            <Option value={product} key={product}>{product}</Option>
                          ))
                        }
                      </Select>
                    </Div>
                  </div>
                )
              }
              <div style={{ marginBottom: '10px' }}>
                <Radio.Group onChange={this.changeRadio} value={radioValue}>
                  <Radio value={1}>Single</Radio>
                  <Radio value={0}>Multiple</Radio>
                </Radio.Group>
              </div>
              { radioValue ? 
                <div>
                  <Input value={singelIMEI} onChange={this.changeInput} placeholder='Please enter an IMEI' style={{marginBottom:'10px'}}></Input>                                  
                </div>
                :
              <MyUpload {...props} fileList={fileList}>
                <div style={{ marginBottom: '10px' }}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>
                {t('Download Template(.xls)')}</TemplateLink>
                <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>
                {t('Download Template(.cvs)')}
                </TemplateLink>
                </div>
                <Button type="primary">
                  <Icon type="upload"></Icon>
                  {t('Import IMEI')}
                </Button>
              </MyUpload>
              }
            </Modal>  
          )
        }
        {
          deleteDialogShow&&(
            <Modal title={t('Import IMEI')} visible={deleteDialogShow} onOk={this.handleDeleteOk} onCancel={this.handleDeleteCancel} okText={t('OK')}>
               <div style={{ marginBottom: '10px' }}>
                <Radio.Group onChange={this.changeDeleteRadio} value={deleteRadioValue}>
                  <Radio value={1}>Single</Radio>
                  <Radio value={0}>Multiple</Radio>
                </Radio.Group>
              </div>
              { deleteRadioValue ? 
                <div>
                  <Input value={deleteSingelIMEI} onChange={this.changeDeleteInput} placeholder='Please enter an IMEI' style={{marginBottom:'10px'}}></Input>                                  
                </div>
                :
              <MyUpload {...deleteProps} fileList={deleteFileList}>
                <div style={{ marginBottom: '10px' }}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.xls)')}</TemplateLink>
                <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.cvs)')}</TemplateLink>
                </div>
                <Button type="primary">
                  <Icon type="upload"></Icon>
                  {t('Import IMEI')}
                </Button>
              </MyUpload>
              }
            </Modal>
          )
        }
      </div>
    );
  }
}

const mapStateToProps=(state)=>{
  return {
    menus:state.menus,
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(UploadIMEI))
